/**
 * Tasks API — list, create, invoice sync.
 * Delegates to client.js; returns raw Response for unchanged caller behavior.
 */

import { request } from "./client";

export function getTasks() {
  return request("/tasks/", { method: "GET" });
}

export function createTask(task) {
  return request("/tasks/", { method: "POST", body: task });
}

/**
 * Permanently deletes a task. Backend blocks deletion (409) of tasks that
 * already have a successful QuickBooks invoice sync unless force=true is
 * passed, so a real, already-invoiced record can't be removed by mistake.
 * @param {string} taskId
 * @param {{ force?: boolean }} [opts]
 */
export function deleteTask(taskId, { force = false } = {}) {
  const qs = force ? "?force=true" : "";
  return request(`/tasks/${taskId}${qs}`, { method: "DELETE" });
}

/**
 * @param {string} taskId
 * @param {{ total: number; clientName: string; line_items: object[] }} body
 */
export function syncInvoice(taskId, body) {
  return request(`/invoices/sync/${taskId}`, { method: "POST", body });
}
